import { BaseEvent } from 'components';

export const mergeAdjacentAvailabilities = (availabilities: BaseEvent[]) => {
  const sortedAvailabilities = availabilities.sort(
    (a, b) => a.start.getTime() - b.start.getTime(),
  );

  const mergedAvailabilities = sortedAvailabilities.reduce((acc, curr) => {
    const last = acc[acc.length - 1];
    if (last && last.end.getTime() >= curr.start.getTime()) {
      if (curr.end > last.end) {
        last.end = curr.end;
      }
      return acc;
    }
    return [...acc, curr];
  }, [] as BaseEvent[]);

  return mergedAvailabilities;
};

export const clearAvailabilitiesForGroup = (availabilities: BaseEvent[]) => {
  const sortedAvailabilities = availabilities.sort(
    (a, b) => a.start.getTime() - b.start.getTime(),
  );

  const mergedAvailabilities = sortedAvailabilities.reduce((acc, curr) => {
    const last = acc[acc.length - 1];
    if (last && last.end.getTime() > curr.start.getTime()) {
      return acc;
    }
    return [...acc, curr];
  }, [] as BaseEvent[]);

  return mergedAvailabilities;
};
